// src/services/ga4Config.js

// Configuration Google Analytics 4
export const GA4_MEASUREMENT_ID = 'G-G9FGYMQPGG';

// Initialiser GA4
export const initGA4 = () => {
  if (typeof window === 'undefined') return;
  
  // Vérifier si GA4 est déjà chargé
  if (window.gtag) {
    console.log('✅ GA4 déjà initialisé');
    return;
  }

  // Charger le script GA4
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialiser gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: true,
    cookie_flags: 'SameSite=None;Secure'
  });

  console.log('✅ GA4 initialisé avec ID:', GA4_MEASUREMENT_ID);
};
